"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overwrite = exports.OVERWRITE_METADATA_KEY = void 0;
const reflect_metadata_1 = require("@rxap/reflect-metadata");
exports.OVERWRITE_METADATA_KEY = 'rxap-mixin-overwrite';
function Overwrite(onlySelf = true) {
    return function (target, propertyKey) {
        (0, reflect_metadata_1.addToMetadata)(exports.OVERWRITE_METADATA_KEY, propertyKey, target);
        (0, reflect_metadata_1.setMetadata)(exports.OVERWRITE_METADATA_KEY, onlySelf, target, propertyKey);
    };
}
exports.Overwrite = Overwrite;
